import { BreadcrumbNav } from "web/components/ObjectList"

import { ViewFilters, Toolbar, ViewSettings, ViewActions } from "web/components"
import routes from "web/routes/constants"

import { LocalizationContext } from "web/contexts"

export default function Layout({
  view,
  viewGroup,
  viewLocalizationContextValue,
  user,
  children,
  handleViewSaveAs,
  handleViewReset,
  handleViewUpdate,
  handleViewRename,
  handleViewDelete,
  handleViewShare,
  handleUpdateViewUnits,
  ...rest
}) {
  const viewCrumbs = [
    { name: "Tasks" },
    {
      href: routes.view("tasks", viewGroup.slug, null),
      name: viewGroup.name,
      current: view.isViewGroup,
    },
  ]

  if (!view.isViewGroup) {
    viewCrumbs.push({
      href: routes.view("tasks", viewGroup.slug, view.id),
      name: view.name,
      current: true,
    })
  }

  return (
    <LocalizationContext.Provider value={viewLocalizationContextValue}>
      <Toolbar>
        <Toolbar.Heading>
          <BreadcrumbNav crumbs={viewCrumbs} />
          <ViewActions
            view={view}
            onViewSaveAs={handleViewSaveAs}
            onViewReset={handleViewReset}
            onViewUpdate={handleViewUpdate}
          />
        </Toolbar.Heading>
        <div className="px-3 md:px-5">
          <Toolbar.Actions>
            <div className="flex items-center space-x-2">
              <ViewSettings
                view={view}
                user={user}
                isGroupView={view.isViewGroup}
                onRename={handleViewRename}
                onDelete={handleViewDelete}
                onShare={handleViewShare}
                onUpdateUnits={handleUpdateViewUnits}
              />
            </div>
          </Toolbar.Actions>
        </div>
      </Toolbar>
      <ViewFilters
        subjectType="task"
        availableFields={view.available_fields}
        filterConditions={view.conditions}
        groupConditions={view.group_conditions}
        stickyConditions={view.sticky_conditions || []}
        containerClasses="my-2 px-3 md:my-3 md:px-5"
        {...rest}
      />
      {children}
    </LocalizationContext.Provider>
  )
}
